// tslint:disable
export enum Extauth2ValidateStatus {
    /**
     * @description Password is valid
     */
    Valid = 0,
    /**
     * @description Username is valid
     */
    UserFound = 1,
    /**
     * @description Password invalid
     */
    Invalid = 2,
    /**
     * @description Username not found
     */
    UserNotFound = 3,
    /**
     * @description Account is disabled
     */
    AccountDisabled = 4,
    /**
     * @description Account is locked
     */
    AccountLocked = 5,
    /**
     * @description Password has expired
     */
    PasswordExpired = 6,
    /**
     * @description An unexpected server error has occurred
     */
    ServerError = 7,
    /**
     * @description User must change password
     */
    UserMustChangePassword = 8,
}
(Extauth2ValidateStatus as any)['VALID'] = 0;
(Extauth2ValidateStatus as any)['USERFOUND'] = 1;
(Extauth2ValidateStatus as any)['INVALID'] = 2;
(Extauth2ValidateStatus as any)['USERNOTFOUND'] = 3;
(Extauth2ValidateStatus as any)['ACCOUNTDISABLED'] = 4;
(Extauth2ValidateStatus as any)['ACCOUNTLOCKED'] = 5;
(Extauth2ValidateStatus as any)['PASSWORDEXPIRED'] = 6;
(Extauth2ValidateStatus as any)['SERVERERROR'] = 7;
(Extauth2ValidateStatus as any)['USERMUSTCHANGEPASSWORD'] = 8;
